"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VerifyTradePwdForResetRequest = void 0;
var VerifyTradePwdForResetRequest = /** @class */ (function () {
    function VerifyTradePwdForResetRequest() {
    }
    return VerifyTradePwdForResetRequest;
}());
exports.VerifyTradePwdForResetRequest = VerifyTradePwdForResetRequest;
;
//# sourceMappingURL=verifyTradePwdForReset.request.js.map